module.exports = __webpack_public_path__ + "media/images/default/pages/public_sciences/main/3-276d8a1785e650cd4169783bc5fb51d4.svg";